import React, { useState, useEffect, useCallback } from 'react';
import images from '../../images';
import IntegrationCard from '../Cards/IntegrationCard';
import IntegrationModal from '../Modals/IntegrationModal';
import { apiRequest } from '../../api/index';
import {getUserData} from "../../api/userData";

const ProfileIntegrations = ({loading: loadingMain,  userData }) => {
  const [integrations, setIntegrations] = useState([]);
  const [loading, setLoading] = useState(loadingMain);
  const [error, setError] = useState(null);
  const [showIntegrationModal, setShowIntegrationModal] = useState(false);
  const [flows, setFlows] = useState([]);
  
  // Загрузка данных интеграций
  const loadIntegrations = useCallback(async () => {
    if (!userData?.id) {
      return;
    }
    try {
      setLoading(true);
      setError(null);
      
      const integrationsData = await apiRequest(`integrations/${userData.id}/list`, 'GET');
      const flowsData = await getUserData(userData.id);
      const userFlows = flowsData?.flows;
      console.log("userFlows: ", userFlows);
      
      // Добавляем flows к каждой интеграции, у которой integration_id совпадает
      const updatedIntegrations = (integrationsData.data.integrations || []).map(integration => {
        const integrationFlows = userFlows?.filter(flow => flow.integration_id === integration.id) || [];
        return {
          ...integration,
          flows: integrationFlows
        };
      });
      
      setIntegrations(updatedIntegrations);
      
    } catch (error) {
      console.error('Ошибка при загрузке интеграций:', error);
      setError(error.message || 'Не удалось загрузить интеграции');
    } finally {
      setLoading(false);
    }
  }, [userData?.id]);

  // Загрузка данных потоков
  const loadFlows = useCallback(async () => {
    if (!userData?.id) {
      return;
    }
    try {
      setLoading(true);
      const flowsData = await getUserData(userData.id);
      setFlows(flowsData.flows || []);
    } finally {
      setLoading(false);
    }
  }, [userData?.id]);

  // Загружаем данные при монтировании
  useEffect(() => {
    loadIntegrations();
    loadFlows();
  }, [loadIntegrations, loadFlows]);
  
  const openIntegrationModal = () => {
    setShowIntegrationModal(true);
  };

  const closeIntegrationModal = () => {
    setShowIntegrationModal(false);
  };

  const handleIntegrationCreated = async () => {
    // Перезапрашиваем интеграции через loadIntegrations
    await loadIntegrations();
  };
  
  console.log("integrations: ", integrations);
  return (
    <div className="profile-under">
      <div className="profile-integration-header">
        <div className="profile-integration-title">
          <img
            src={images.qrCode}
            alt=""
            className="profile-integration-icon"
          />
          Интеграции
        </div>
        <button className="btn btn-primary" onClick={openIntegrationModal}>Добавить интеграцию</button>
      </div>
      <div className="profile-integrations-list">
        {(loading || integrations.length === 0) ? (
              <div className="no-flows-placeholder">
                <img
                    src={images.qrCodeBrokenBig}
                    alt="Пусто"
                />
                <p>Тут пока ничего нет : (</p>
              </div>
            )
            : error ? (
                <div className="no-integrations">{error}</div>
            ) : (
                integrations.map((integration) => (
                    <IntegrationCard
                        key={integration.id}
                        integration={integration}
                        flows={integration.flows || []}
                        onIntegrationUpdated={handleIntegrationCreated}
                        userData={userData}
              />
            ))
          )
        }
      </div>
      <IntegrationModal
        isOpen={showIntegrationModal}
        onClose={closeIntegrationModal}
        onIntegrationCreated={handleIntegrationCreated}
        userData={userData}
      />
    </div>
  );
};

export default ProfileIntegrations;
